export interface ILocalizeInjector {
  interpolate: (id: string, data?: Record<string, any>) => string;
}

//internalize required content
function globalState() {
  // @ts-expect-error Global state for webmodule components
  if (!globalThis.webmoduleComponents) globalThis.webmoduleComponents = {};
  // @ts-expect-error Global state for webmodule components
  return globalThis.webmoduleComponents;
}

export function setLocalizeInjector(injector: ILocalizeInjector): void {
  if (!injector || typeof injector.interpolate !== 'function') {
    throw new Error('Invalid localize injector provided');
  }
  const state = globalState();
  state.componentslocalizeInjector ??= injector;
}

export function getLocalizeInjector(): ILocalizeInjector {
  const state = globalState();
  if (!state.componentslocalizeInjector) {
    throw new Error('Localize injector is not set');
  }
  return state.componentslocalizeInjector;
}
